export { PdfViewerComponent, Zoom, ZoomConstants } from './pdf-viewer.component';
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
